import { useClickAway as a } from "./index.es130.js";
import "react";
import { DATE_MASK_VALUE as c } from "./index.es652.js";

var E = function E(_ref) {
  var r = _ref.from,
      l = _ref.to,
      e = _ref.setIsOpen,
      t = _ref.inputRef,
      n = _ref.wrapperRef;

  var u = function u(_ref2) {
    var _t$current;

    var o = _ref2.code;
    o === "Enter" && r.length === c.length && l.length === c.length && ((_t$current = t.current) !== null && _t$current !== void 0 && _t$current.blur(), e(!1));
  },
      m = function m() {
    setTimeout(function () {
      var _n$current;

      document.activeElement !== document.body && !((_n$current = n.current) !== null && _n$current !== void 0 && _n$current.contains(document.activeElement)) && e(!1);
    });
  },
      i = function i(o) {
    var _t$current2;

    o.code === "Escape" && ((_t$current2 = t.current) !== null && _t$current2 !== void 0 && _t$current2.blur(), e(!1));
  };

  return a(n, function () {
    setTimeout(function () {
      [t.current].includes(document.activeElement) || e(!1);
    });
  }), {
    onInputKeyDown: u,
    onWrapperKeyDown: i,
    onBlur: m
  };
};

export { E as useClosePopup };